export type PartnerLink = { href: string; label: string };

export type MarketingPartnerDef = {
  id: string;
  faviconDomain: string;
  /** Local image path when favicon is not suitable (e.g. wordmark). */
  logoSrc?: string;
  logoWide?: boolean;
  nameKey: string;
  descKey: string;
  links: PartnerLink[];
  emails?: { href: string; label: string }[];
  /** Affiliate / locale-aware partner page. */
  localeAwareHref?: boolean;
};

/** Same partners as the marketing home page; used in portal sidebar too. */
export const MARKETING_PARTNERS: MarketingPartnerDef[] = [
  {
    id: 'evi',
    faviconDomain: 'evi.rs',
    nameKey: 'partners.evi.name',
    descKey: 'partners.evi.desc',
    links: [
      { href: 'https://evi.rs', label: 'evi.rs' },
      { href: 'https://evisolutions.io', label: 'evisolutions.io' },
    ],
    emails: [{ href: 'mailto:office@evi.rs', label: 'office@evi.rs' }],
  },
  {
    id: 'tim011',
    faviconDomain: 'knjigovodja.in.rs',
    nameKey: 'partners.tim011.name',
    descKey: 'partners.tim011.desc',
    links: [{ href: 'https://knjigovodja.in.rs/sh', label: 'knjigovodja.in.rs' }],
  },
  {
    id: 'intrascope',
    faviconDomain: 'intrascope.app',
    nameKey: 'partners.intrascope.name',
    descKey: 'partners.intrascope.desc',
    links: [{ href: 'https://intrascope.app', label: 'intrascope.app' }],
  },
  {
    id: 'capitaale',
    faviconDomain: 'capitaale.com',
    logoSrc: '/images/capitaale-logo.png',
    logoWide: true,
    nameKey: 'partners.capitaale.name',
    descKey: 'partners.capitaale.desc',
    links: [{ href: 'https://capitaale.com/en/partner/top14?ref=top14&utm_source=top14&utm_medium=partner', label: 'capitaale.com' }],
    localeAwareHref: true,
  },
];
